@if (user === null) {
  <!-- หน้าว่างเปล่า รอ redirect -->
} @else if ( user && (userEnable && !user?.pid) ) {
  <div class="row">
    <div class="card custom-box my-3 border-0 ">
      <div class="card-body">
        <div class="row mt-3">
          <div class="text-center">
            <h3>
              ผู้ใช้งาน {{ user?.preferred_username }} ({{ user?.name }}) นี้ยังไม่ได้ผูก ThaID <br/>
              กรุณายืนยันตัวตนด้วยแอปพลิเคชั่น ThaID
            </h3>
          </div>
        </div>
        <div class="row mt-5 mb-5">
          <div class="text-center">
            <a [href]="setPidUrl"
               class="btn btn-custom btn-custom-theme btn-thaid me-2 w-75">
              คลิก เพื่อยืนยันตัวตนด้วยแอปพลิเคชั่น ThaID
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else if (user && (!userEnable && !user?.resource_access?.['qrtraces'])) {
  <div class="row">
    <div class="card custom-box my-3 border-0 ">
      <div class="card-body">
        <div class="row mt-3">
          <div class="text-center">
            <h3>
              ผู้ใช้งาน {{ user?.preferred_username }} ({{ user?.name }}) นี้ยังถูกระงับสิทธิ์ในการเข้าสู่ระบบ หรือ
              ผู้ใช้งานนี้ถูกปิดการใช้งาน
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
}

